var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRtf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17V3C7 1.896 7.896 1 9 1H31L39 9V37C39 38.104 38.104 39 37 39H9C7.896 39 7 38.104 7 37V31",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 10H30V4",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.92 31H3.08C1.93184 31 1 30.104 1 29V19C1 17.896 1.93184 17 3.08 17H24.92C26.0682 17 27 17.896 27 19V29C27 30.104 26.0682 31 24.92 31Z",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 19.9H7.83C8.71667 19.9 9.38667 20.0567 9.84 20.37C10.2933 20.6833 10.52 21.24 10.52 22.04C10.52 22.58 10.45 23.01 10.31 23.33C10.17 23.65 9.91 23.9 9.53 24.08L10.64 28H8.79L7.9 24.37H7.39V28H5.6V19.9ZM7.89 23.34C8.25 23.34 8.5 23.2467 8.64 23.06C8.78667 22.8667 8.86 22.58 8.86 22.2C8.86 21.8333 8.79333 21.56 8.66 21.38C8.52667 21.1933 8.29667 21.1 7.97 21.1H7.39V23.34H7.89ZM12.748 21.23H11.528V19.9H15.758V21.23H14.548V28H12.748V21.23ZM16.9711 19.9H20.4711V21.11H18.7611V23.15H20.2511V24.4H18.7611V28H16.9711V19.9Z",
    fill: "#E37021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtf);
export default __webpack_public_path__ + "static/media/rtf.9965c6518c5afac5c1b3ce97072cb639.svg";
export { ForwardRef as ReactComponent };